import gql from "graphql-tag";
const getRefsQuery = gql(` 
query GetRef($params: AWSJSON!) {
  getRef(params: $params) {
    result
  }
}
`)
export default getRefsQuery;
